export interface TaskLinkType {
  id: number;
  name: string;
  key: string
}

